module.exports = __webpack_public_path__ + "static/media/gamesWon_100000_500000.15cf259a.png";